/* import __COLOCATED_TEMPLATE__ from './right-left-in-box.hbs.js'; */
import Component from '@glimmer/component';
export default class RightLeftInBox extends Component {
  // Use ...attributes instead of args for SVG specific properties, ex: height
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
}